(() => {
  'use strict';
  const root = document.getElementById('NxcChallenge');
  if (!root || root.dataset.nxcReady === '1') return;
  root.dataset.nxcReady = '1';

  /* SINGLE SOURCE OF TRUTH for both hero + popup countdown.
     Keep COUNTDOWN_END empty until the owner says: start countdown.
     When activated later, set ONE fixed end timestamp and both timers stay synced. */
  const timer = root.querySelector('[data-nxc-countdown]');
  const COUNTDOWN_END = '';
  const COUNTDOWN_DAYS = 45;
  const daysEl = root.querySelector('[data-nxc-days]');
  const hoursEl = root.querySelector('[data-nxc-hours]');
  const minutesEl = root.querySelector('[data-nxc-minutes]');
  const popupTimer = root.querySelector('[data-nxc-popup-countdown]');
  const popupDaysEl = root.querySelector('[data-nxc-popup-days]');
  const popupHoursEl = root.querySelector('[data-nxc-popup-hours]');
  const popupMinutesEl = root.querySelector('[data-nxc-popup-minutes]');
  const pad = (value) => String(value).padStart(2, '0');
  let countdownInterval = null;

  const paintCountdown = () => {
    let totalMinutes = COUNTDOWN_DAYS * 24 * 60;

    if (COUNTDOWN_END) {
      const end = Date.parse(COUNTDOWN_END);
      if (Number.isFinite(end)) {
        totalMinutes = Math.max(0, Math.ceil((end - Date.now()) / 60000));
      }
    }

    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    const label = `${days} days ${hours} hours ${minutes} minutes remaining`;

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (timer) timer.setAttribute('aria-label', label);

    if (popupDaysEl) popupDaysEl.textContent = pad(days);
    if (popupHoursEl) popupHoursEl.textContent = pad(hours);
    if (popupMinutesEl) popupMinutesEl.textContent = pad(minutes);
    if (popupTimer) popupTimer.setAttribute('aria-label', label);

    if (COUNTDOWN_END && totalMinutes <= 0 && countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  };

  paintCountdown();
  const syncCountdown = () => {
    clearInterval(countdownInterval);
    countdownInterval = null;
    if (document.hidden || !COUNTDOWN_END) return;
    paintCountdown();
    const end = Date.parse(COUNTDOWN_END);
    if (Number.isFinite(end) && end > Date.now()) countdownInterval = window.setInterval(paintCountdown, 60000);
  };
  syncCountdown();
  document.addEventListener('visibilitychange', syncCountdown);
  window.addEventListener('pagehide', () => clearInterval(countdownInterval));
  window.addEventListener('pageshow', syncCountdown);

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;
  const reveals = Array.from(root.querySelectorAll('[data-nxc-reveal]'));

  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  } else {
    root.classList.add('nxc-motion-ready');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px 40px 0px' });
    reveals.forEach((el) => io.observe(el));
  }


  const hero = root.querySelector('.nxc-hero');
  const media = root.querySelector('.nxc-hero__media');
  const steps = root.querySelector('[data-nxc-steps]');
  const progress = steps?.querySelector('.nxc-steps__line span');
  const stepItems = steps ? Array.from(steps.querySelectorAll('.nxc-step')) : [];
  let heroVisible = false;
  let stepsVisible = false;
  let frame = 0;

  const update = () => {
    frame = 0;
    if (document.hidden) return;
    const heroRect = heroVisible && !reduce && window.innerWidth > 700 ? hero?.getBoundingClientRect() : null;
    const stepsRect = stepsVisible ? steps?.getBoundingClientRect() : null;
    const vh = window.innerHeight || 1;
    if (media && heroRect) {
      const p = Math.max(0, Math.min(1, -heroRect.top / Math.max(heroRect.height, 1)));
      media.style.transform = `translate3d(0,${p * 12}px,0) scale(${1 + p * 0.012})`;
    }
    if (stepsRect && progress) {
      const p = Math.max(0, Math.min(1, (vh * 0.8 - stepsRect.top) / (stepsRect.height + vh * 0.18)));
      progress.style.transform = `scaleX(${p})`;
      stepItems.forEach((step, index) => step.classList.toggle('is-progressed', p >= (index + 0.35) / stepItems.length));
    }
  };
  if (reduce && progress) {
    progress.style.transform = 'scaleX(1)';
    stepItems.forEach(step => step.classList.add('is-progressed'));
  }
  const schedule = () => {
    if (reduce) return;
    if (!frame && !document.hidden && (heroVisible || stepsVisible)) frame = requestAnimationFrame(update);
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === steps) stepsVisible = entry.isIntersecting;
      });
      schedule();
    }, { rootMargin: '80px' });
    if (hero) observer.observe(hero);
    if (steps) observer.observe(steps);
  } else {
    heroVisible = stepsVisible = true;
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', () => {
    if (media && (reduce || window.innerWidth <= 700)) media.style.removeProperty('transform');
    schedule();
  });
  document.addEventListener('visibilitychange', schedule);
  schedule();
})();

/* NXC CONTEST EXPLAINER MODAL 2026-09-20 */
(() => {
  const popup = document.querySelector('[data-nxc-explainer]');
  if (!popup || popup.dataset.ready === '1') return;
  popup.dataset.ready = '1';

  const closeButton = popup.querySelector('[data-nxc-explainer-close]');
  const actionLinks = Array.from(popup.querySelectorAll('[data-nxc-explainer-action]'));
  let previousFocus = null;
  const background = [];
  let branch = popup;
  while (branch.parentElement && branch !== document.body) {
    for (const sibling of branch.parentElement.children) {
      if (sibling !== branch && sibling instanceof HTMLElement && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
        background.push([sibling, sibling.inert]);
      }
    }
    branch = branch.parentElement;
  }

  const lockPage = () => {
    background.forEach(([element]) => { element.inert = true; });
    document.documentElement.classList.add('nxc-popup-open');
    document.body.classList.add('nxc-popup-open');
  };

  const unlockPage = () => {
    background.forEach(([element, wasInert]) => { element.inert = wasInert; });
    document.documentElement.classList.remove('nxc-popup-open');
    document.body.classList.remove('nxc-popup-open');
  };

  const hidePopup = (restoreFocus = true) => {
    popup.hidden = true;
    unlockPage();
    if (restoreFocus && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  };

  previousFocus = document.activeElement;
  popup.hidden = false;
  lockPage();

  window.requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));

  closeButton?.addEventListener('click', () => hidePopup());

  actionLinks.forEach((link) => {
    link.addEventListener('click', () => {
      hidePopup(false);
      const target = document.getElementById(link.hash.slice(1));
      if (target) {
        if (!target.hasAttribute('tabindex')) target.tabIndex = -1;
        target.focus({ preventScroll: true });
      }
    });
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup || event.target.classList.contains('nxc-explainer__backdrop')) {
      event.preventDefault();
    }
  });

  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      hidePopup();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      popup.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
    ).filter((el) => !el.hidden && el.offsetParent !== null);

    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

